<template>
  <div class="search-bar-wrapper">
    <!-- 搜索和筛选区域 -->
    <div class="sc-YtoFE hCpAqU">
      <!-- 移动端搜索框 -->
      <!-- <input class="sc-eIrltS csdMjD d-block d-sm-none form-control" type="text" v-model="searchQuery" placeholder="搜索产品..."> -->
      
      <!-- PC端布局 - 完全保持原样 -->
      <div class="d-none d-md-block">
        <form>
          <div class="row">
            <!-- <div class="col-md-7" style="display: flex; flex-flow: wrap;">
              <input class="sc-eIrltS csdMjD d-none d-md-block form-control" type="text" v-model="searchQuery" placeholder="Search products...">
              <div class="sc-vjKnw fnEdnh" style="margin-right: 20px;">
                <input id="min-filter" min="0" placeholder="Min Price" step="0.01" type="number" class="form-control" v-model="minPrice" style="border: none;">
              </div>
              <div class="sc-vjKnw fnEdnh">
                <input id="max-filter" min="0" placeholder="Max Price" step="0.01" type="number" class="form-control" v-model="maxPrice" style="border: none;">
              </div>
            </div> -->
            <div class="sc-dExYQz eyBMWW col-md-5" style="justify-content: flex-start;">
              <div class="sc-crPCXo cFyuiL">
                <select class="sc-eFqGBh igOwiI" style="width: 300px;" v-model="sortBy">
                  <option value="1">Default</option>
                  <option value="2">Most Clicks</option>
                  <option value="3">Price: Low to High</option>
                  <option value="4">Price: High to Low</option>
                </select>
              </div>
            </div>
          </div>
          <!-- <div class="sc-etAVug ctvquR d-block d-md-none">
            <div class="sc-fGjrnr jXknhi">
              <label for="rebate-only" class="checkbox-container">
                <input id="rebate-only" type="checkbox" v-model="filters.cashback">
                <span class="sc-gHbYXZ dqOZJL"></span>
              </label>
              <label for="rebate-only" class="sc-dlUsjx hMUgRq">
                <span class="sc-bjMMwb ibUCJj mar-5-left">show only</span>
                <span class="sc-bqWVmG gHbRpy mar-5-left">cash back</span>
              </label>
            </div>
            <div class="sc-fGjrnr jXknhi">
              <label for="fba-filter" class="checkbox-container">
                <input id="fba-filter" type="checkbox" class="prime" v-model="filters.prime">
                <span class="sc-gHbYXZ dqOZJL"></span>
              </label>
              <label for="fba-filter" class="sc-dlUsjx hMUgRq">
                <span class="sc-bjMMwb ibUCJj mar-5-left">show only</span>
                <span class="sc-bqWVmG gHbRpy mar-5-left">prime</span>
              </label>
            </div>
            <div class="sc-fGjrnr jXknhi">
              <label for="nsfw-filter" class="checkbox-container">
                <input id="nsfw-filter" type="checkbox" v-model="filters.intimates">
                <span class="sc-gHbYXZ dqOZJL"></span>
              </label>
              <label for="nsfw-filter" class="sc-dlUsjx hMUgRq">
                <span class="sc-bjMMwb ibUCJj mar-5-left">show</span>
                <span class="sc-bqWVmG gHbRpy mar-5-left">intimates</span>
              </label>
            </div>
          </div> -->
        </form>
      </div>
      
      <!-- 移动端 Show Filters 按钮 -->
      <!-- <div class="sc-imaUOB iWuFyR d-md-none" @click="toggleFilters">
        <span>{{ showFilters ? 'Hide Filters' : 'Show Filters' }}
          <i class="fa" :class="showFilters ? 'fa-angle-up' : 'fa-angle-down'" style="padding-left: 7px;"></i>
        </span>
      </div> -->
      
      <!-- 移动端筛选器 - 可折叠  v-show="showFilters" -->
      <div class="mobile-filters-panel">
        <!-- <div class="mobile-filter-row">
          <input type="number" v-model="minPrice" placeholder="Min Price" class="form-control mobile-input">
          <input type="number" v-model="maxPrice" placeholder="Max Price" class="form-control mobile-input"> -->
        <!-- </div> -->
        <select v-model="sortBy" class="form-control mobile-select">
          <option value="1">Default</option>
          <option value="2">Most Clicks</option>
          <option value="3">Price: Low to High</option>
          <option value="4">Price: High to Low</option>
        </select>
        <!-- <div class="mobile-checkboxes">
          <label class="mobile-checkbox">
            <input type="checkbox" v-model="filters.cashback">
            <span>show only <strong>cash back</strong></span>
          </label>
          <label class="mobile-checkbox">
            <input type="checkbox" v-model="filters.prime">
            <span>show only <strong>prime</strong></span>
          </label>
          <label class="mobile-checkbox">
            <input type="checkbox" v-model="filters.intimates">
            <span>show <strong>intimates</strong></span>
          </label>
        </div> -->
      </div>
    </div>
    
    <!-- 标签页 -->
    <!-- <div class="sc-GJyyB ftrnRI">
      <div style="flex: 1 1 0%;">
        <span class="sc-eGFuAX" :class="activeTab === 'all' ? 'jHtPUC' : 'eXdDXk'" @click="activeTab = 'all'">All Deals</span>
        <span class="sc-eGFuAX" :class="activeTab === 'upcoming' ? 'jHtPUC' : 'eXdDXk'" @click="activeTab = 'upcoming'">Upcoming</span>
      </div>
      <div class="sc-dXoxLi cVKLbe d-none d-md-flex">
        <div class="sc-jFJHMl jknZLW">
          <label for="rebate-only-desktop" class="checkbox-container">
            <input id="rebate-only-desktop" type="checkbox" v-model="filters.cashback">
            <span class="sc-yJYNr gWUshf"></span>
          </label>
          <label for="rebate-only-desktop" class="sc-fYzRkI gQEGuv">
            <span class="sc-jYvNne iKref mar-5-left">show only</span>
            <span class="sc-kZCGdI ctoneP mar-5-left">cash back</span>
          </label>
        </div>
        <div class="sc-jFJHMl jknZLW">
          <label for="fba-filter-desktop" class="checkbox-container">
            <input id="fba-filter-desktop" type="checkbox" class="prime" v-model="filters.prime">
            <span class="sc-yJYNr gWUshf"></span>
          </label>
          <label for="fba-filter-desktop" class="sc-fYzRkI gQEGuv">
            <span class="sc-jYvNne iKref mar-5-left">show only</span>
            <span class="sc-kZCGdI ctoneP mar-5-left">prime</span>
          </label>
        </div>
        <div class="sc-jFJHMl jknZLW">
          <label for="nsfw-filter-desktop" class="checkbox-container">
            <input id="nsfw-filter-desktop" type="checkbox" v-model="filters.intimates">
            <span class="sc-yJYNr gWUshf"></span>
          </label>
          <label for="nsfw-filter-desktop" class="sc-fYzRkI gQEGuv">
            <span class="sc-jYvNne iKref mar-5-left">show</span>
            <span class="sc-kZCGdI ctoneP mar-5-left">intimates</span>
          </label>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'SearchBar',
  data() {
    return {
      searchQuery: '',
      minPrice: '',
      maxPrice: '',
      sortBy: '1', // 1=默认，2=点击量，3=价格升序，4=价格降序
      activeTab: 'all',
      filters: {
        cashback: false,
        prime: false,
        intimates: false
      },
      showFilters: false
    }
  },
  watch: {
    searchQuery() { this.emitFilters() },
    minPrice() { this.emitFilters() },
    maxPrice() { this.emitFilters() },
    sortBy() { this.emitFilters() },
    activeTab() { this.emitFilters() },
    filters: {
      handler() { this.emitFilters() },
      deep: true
    }
  },
  methods: {
    emitFilters() {
      this.$emit('filter-change', {
        searchQuery: this.searchQuery,
        minPrice: this.minPrice,
        maxPrice: this.maxPrice,
        order: parseInt(this.sortBy), // 转换为数字类型
        tab: this.activeTab,
        filters: this.filters
      })
    },
    toggleFilters() {
      this.showFilters = !this.showFilters
    }
  }
}
</script>

<style scoped>
/* 只添加移动端样式,PC端完全不动 */
.csdMjD {
  border: none;
  background: url(@/assets/images/header/search.svg) 20px 10px no-repeat rgb(255, 255, 255);
  flex: 4 1 0%;
  margin-bottom: 15px;
  margin-right: 20px;
  min-width: 300px;
  width: 100%;
  padding-left: 55px !important;
}

.hCpAqU input {
  height: 38px;
  padding-left: 14px;
}

.fnEdnh {
  flex: 1 1 0%;
  margin-right: 20px;
}

.eyBMWW {
  display: flex;
  -webkit-box-pack: end;
  justify-content: flex-end;
}

.cFyuiL {
  margin-right: 20px;
}

.igOwiI {
  appearance: none;
  border: none;
  background: url(@/assets/images/header/select-arrow-new.png) right 10px top 13px / 10px no-repeat rgb(255, 255, 255);
  color: rgb(170, 170, 170);
  cursor: pointer;
  font-size: 14px;
  height: 38px;
  outline: none;
  padding: 7px 30px 7px 15px;
  width: 100%;
}

.ctvquR {
  display: flex;
  flex: 1 1 0%;
  flex-direction: column;
  -webkit-box-pack: end;
  justify-content: flex-end;
  margin-top: 15px;
}

.jXknhi {
  -webkit-box-align: center;
  align-items: center;
  display: flex;
  margin: 5px 0px;
}

.hCpAqU input {
  height: 38px;
  padding-left: 14px;
}

.dqOZJL {
  background-color: rgb(247, 247, 247);
  border: 2px solid rgb(0, 0, 0);
  border-radius: 50%;
  height: 24px;
  position: absolute;
  top: 0px;
  width: 24px;
}

.ftrnRI {
  -webkit-box-align: center;
  align-items: center;
  display: flex;
  margin: 20px 0px 0px;
}

.jHtPUC {
  color: rgb(0, 0, 0);
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  padding: 7px;
}

.eXdDXk {
  color: rgb(170, 170, 170);
  cursor: pointer;
  display: inline-block;
  font-size: 16px;
  padding: 7px;
}

.cVKLbe {
  display: flex;
  flex: 2 1 0%;
  flex-flow: wrap;
  -webkit-box-pack: end;
  justify-content: flex-end;
}

.jknZLW {
  -webkit-box-align: center;
  align-items: center;
  display: flex;
  margin-right: 20px;
}

.gWUshf {
  background-color: rgb(247, 247, 247);
  border: 2px solid rgb(0, 0, 0);
  border-radius: 50%;
  height: 24px;
  position: absolute;
  top: 0px;
  width: 24px;
}

.gQEGuv {
  cursor: pointer;
  margin-bottom: 0px;
}

.iKref {
  color: rgb(170, 170, 170);
  font-weight: normal;
  font-size: 1rem;
}

.ctoneP {
  color: rgb(0, 0, 0);
  font-size: 1rem;
  font-weight: 700;
}
.bCOUbt {
    height: 24px;
    position: absolute;
    top: 0px;
    width: 24px;
    z-index: 10;
}
/* 移动端筛选面板 - 仅在移动端显示 */
@media (max-width: 767px) {
  .mobile-filters-panel {
    /* padding: 15px; */
    /* background: #f9f9f9; */
    border-radius: 8px;
    margin-top: 10px;
  }

  .mobile-filter-row {
    display: flex;
    gap: 10px;
    margin-bottom: 10px;
  }

  .mobile-input {
    flex: 1;
    font-size: 14px;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }

  .mobile-select {
    width: 100%;
    font-size: 14px;
    padding: 8px 12px;
    margin-bottom: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }

  .mobile-checkboxes {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 15px;
  }

  .mobile-checkbox {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #666;
    cursor: pointer;
  }

  .mobile-checkbox input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }

  .mobile-checkbox strong {
    font-weight: 600;
    color: #000;
  }
}

/* PC端隐藏移动端元素 */
@media (min-width: 768px) {
  .mobile-filters-panel {
    display: none !important;
  }
}
</style>
